"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeadlineType = void 0;
var HeadlineType;
exports.HeadlineType = HeadlineType;

(function (HeadlineType) {
  HeadlineType["SPORT1_HIGHLIGHTS"] = "SPORT1_HIGHLIGHTS";
  HeadlineType["RELATED_CONTENT"] = "RELATED_CONTENT";
})(HeadlineType || (exports.HeadlineType = HeadlineType = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb3JlL2VudW1zL0hlYWRsaW5lVHlwZS50cyJdLCJuYW1lcyI6WyJIZWFkbGluZVR5cGUiXSwibWFwcGluZ3MiOiI7Ozs7OztJQUFZQSxZOzs7V0FBQUEsWTtBQUFBQSxFQUFBQSxZO0FBQUFBLEVBQUFBLFk7R0FBQUEsWSw0QkFBQUEsWSIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBlbnVtIEhlYWRsaW5lVHlwZSB7XG4gICAgU1BPUlQxX0hJR0hMSUdIVFMgPSAnU1BPUlQxX0hJR0hMSUdIVFMnLFxuICAgIFJFTEFURURfQ09OVEVOVCA9ICdSRUxBVEVEX0NPTlRFTlQnLFxufVxuIl19